var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Divisions = MDB.Mangl.Divisions || {};

(function($){
    $.extend(MDB.Mangl.Divisions, {
        bootDivisionLinker: function (divisionDropdown, form, divisionItemContainer) {
            divisionDropdown = $(divisionDropdown);
            form = $(form);
            divisionItemContainer = $(divisionItemContainer);

            var curXhr = undefined;

            divisionDropdown.on('change', function () {
                //Ensure we don't load two sets at the same time
                //creating a race condition for which partial to render last
                if (curXhr !== undefined && curXhr.abort) {
                    curXhr.abort();
                    curXhr = undefined;
                }

                var value = divisionDropdown.val();
                if (!value) {
                    return;
                }

                divisionItemContainer.empty();
                divisionItemContainer.addClass('loading');

                curXhr = $.ajax({
                    url: form.attr('action'),
                    action: 'GET',
                    data: {
                        divisionId: value
                    },
                    success: function(view) {
                        divisionItemContainer.removeClass('loading');
                        divisionItemContainer.html(view);

                        divisionItemContainer.trigger('linker-loaded');
                    },
                    error: function(xhr, status, description){
                        //Ignore aborted requests
                        if(xhr.status === 0 && status === 'abort'){
                            return;
                        }
                        
                        if(xhr.status === 500){
                            status = undefined;
                            description = MDB.loadResourceString('Marketingdb_Ajax_Request_Server_Error_Text');
                        }
                        
                        MDB.alert(description, status)
                    }
                });
            });

            divisionDropdown.kendoDropDownList({
                filter: 'contains'
            });
        }
    });
})(jQuery);